<template>
  <SubHeader
    title="Ajouter un Utilisateur"
    :breads="[{ name: 'Nouveau Dossier' }, { name: 'Courrier' }]"
    :action="{}"
  />
  <form @submit.prevent="prepareBeforeSubmit" class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label" for="user_lastname">Nom</label>
            <input
              required
              type="text"
              name="user_lastname"
              v-model="data.lastname"
              id="user_lastname"
              class="form-control"
              placeholder="Nom"
              value=""
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="user_firstname">Prénom(s)</label>
            <input
              type="text"
              name="user_firstname"
              required
              v-model="data.firstname"
              id="user_firstname"
              class="form-control"
              placeholder="Prénom(s)"
              value=""
            />
          </div>

          <div class="mb-3">
            <label class="form-label" for="user_email">Email</label>
            <input
              required
              type="email"
              name="user_email"
              id="user_email"
              v-model="data.email"
              class="form-control"
              placeholder="Email"
              value=""
            />
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <label class="form-label" for="password">Mot de passe</label>
              <span class="d-block fs-5 text-muted"
                ><a class="link" @click="autoGeneratePassword" href="#"
                  >Auto Generate</a
                >.</span
              >
            </div>

            <input
              required
              :type="showPassword ? 'text' : 'password'"
              name="password"
              id="password"
              v-model="data.password"
              class="form-control"
              placeholder="********"
              value=""
            />
          </div>

          <div class="mb-3 tom-select-custom">
            <label class="form-label" for="user_profile">Roles</label>

            <m-select
              v-model="data.roles_s"
              :loading="profilIsLoading"
              :multiple="true"
              :required="true"
              :options="profilItems"
              :searchable="false"
              placeholder="Liste des roles"
              track-by="id"
              label="name"
              :close-on-select="true"
            >
            </m-select>
          </div>
          <label
            class="row form-check form-switch mb-3"
            for="accounrSettingsPreferencesSwitch2"
          >
            <span class="col-8 col-sm-9 ms-0">
              <span class="d-block text-dark mb-1"
                >S'agit-il d'un utilisateur d'une administration de l'Etat ?</span
              >
              <!-- <span class="d-block fs-5 text-muted"><a class="link" href="#">Quelle est la difference?</a>.</span> -->
            </span>
            <span class="col-4 col-sm-3 text-end">
              <span>Non</span>
              <input
                type="checkbox"
                v-model="showInstitutionSelect"
                class="form-check-input mx-1"
                id="accounrSettingsPreferencesSwitch2"
                checked=""
              />
              <span>Oui</span>
            </span>
          </label>
          <div class="mb-3 tom-select-custom" v-if="showInstitutionSelect">
            <label class="form-label" for="user_profile">Institution</label>
            <m-select
              v-model="data.institution"
              :loading="institutionIsLoading"
              :required="true"
              :options="institutionItems"
              :preselectFirst="true"
              :searchable="false"
              placeholder="Liste des institutions"
              track-by="id"
              label="label"
              :close-on-select="true"
            >
            </m-select>
          </div>
         
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card">
        <div class="card-header card-header-content-md-between bold">
          Caractérisation de la plainte suivie
        </div>
        <div class="card-body">
          <div
            class="mb-3 tom-select-custom"
            v-for="(categ, i) in caracterisationItems"
            :key="i"
          >
            <label
              v-if="categ.type != 'Zone de texte'"
              class="form-label"
              :for="categ.name"
              >{{ categ.name }}</label
            >

            <m-select
              v-if="categ.type != 'Zone de texte'"
              v-model="data.caracterisations[categ.id]"
              :loading="caracterisationIsLoading"
              :options="categ.elements"
              :searchable="true"
              :multiple="true"
              :placeholder="'Liste des ' + categ.name"
              track-by="id"
              label="name"
              :close-on-select="true"
            >
            </m-select>
          </div>
        </div>
        <!-- div class="card-footer"></div -->
      </div>
    </div>
    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <button type="submit" class="btn btn-primary">Enregistrer</button
          >&nbsp;
          <button
            type="button"
            class="btn btn-danger"
            @click="this.$router.back()"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
import notify from "@/utils/notify";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "CreateUser",
  components: {
    SubHeader,
  },
  data() {
    return {
      data: {
        caracterisations: {},
        roles: [],
        roles_s: [],
        institution: null,
        institution_id: null,
        lastname: null,
        firstname: null,
        email: null,
      },
      showInstitutionSelect: false,
      showPassword: false,
    };
  },
  computed: {
    ...mapFields("user/create", {
      userIsLoading: "isLoading",
      userIsSuccess: "isSuccess",
      userShowMessage: "showMessage",
      userMessage: "message",
      userIsCreated: "isCreated",
      userItem: "created",
    }),
    ...mapFields("profil/list", {
      profilIsLoading: "isLoading",
      profilIsSuccess: "isSuccess",
      profilShowMessage: "showMessage",
      profilMessage: "message",
      profilItems: "items",
    }),
    ...mapFields("caracterisation/list", {
      caracterisationIsLoading: "isLoading",
      caracterisationIsSuccess: "isSuccess",
      caracterisationShowMessage: "showMessage",
      caracterisationMessage: "message",
      caracterisationItems: "items",
    }),
    ...mapFields("institution/list", {
      institutionIsLoading: "isLoading",
      institutionIsSuccess: "isSuccess",
      institutionShowMessage: "showMessage",
      institutionMessage: "message",
      institutionItems: "items",
    }),
  },
  methods: {
    ...mapActions({
      handleSubmit: "user/create/create",
      resetUser: "user/create/resetData",
      getProfils: "profil/list/getAll",
      getCaracterisations: "caracterisation/list/getAll",
      getInstitutions: "institution/list/getAll",
      resetProfil: "profil/list/resetData",
      resetCaracterisation: "caracterisation/list/resetData",
      resetInstitution: "institution/list/resetData",
    }),
    prepareBeforeSubmit() {
      var currentData = { ...this.data };

      delete currentData?.profil;
      delete currentData?.institution;
      delete currentData?.roles_s;

      if (!currentData.roles.length) {
        notify("Choissisez le role de l'utilisateur");
        return;
      }

      if (!this.showInstitutionSelect) {
        currentData.institution_id = null;
      }

      if (currentData.caracterisations) {
        const currentDataKeys = Object.keys(currentData.caracterisations);
        const caracterisationKeys = {};
        currentDataKeys.forEach((keys) => {
          let values = currentData.caracterisations[keys];
          caracterisationKeys[keys] = values.map(({ id }) => id);
        });
        currentData.caracterisations = caracterisationKeys;
      }

      this.handleSubmit(currentData);
    },
    autoGeneratePassword() {
      this.data.password = Math.random().toString(36).slice(-8);
      this.showPassword = true;
    },
  },
  watch: {
    userIsCreated(val) {
      if (this.userItem && val) {
        this.$router.push({ name: "AdminUserProfileUser" });
      }
    },

    "data.roles_s"(val) {
      this.data.roles = val?.map(({ id }) => id);
    },
    "data.institution"(val) {
      this.data.institution_id = val?.id;
    },
  },
  mounted() {
    this.getProfils();
    this.getCaracterisations();
    this.getInstitutions();
  },
  unmounted() {
    this.resetUser();
    this.resetProfil();
    this.resetCaracterisation();
    this.resetInstitution();
  },
};
</script>
